import { APP_ROUTES } from '@routes/app-routes.constants';
import { createRoleGuard } from './role.guard';

export const amsManageGuard = createRoleGuard((auth) => auth.canManageAms$, {
  denyPath: APP_ROUTES.accessDenied,
  timeoutPath: APP_ROUTES.home,
});
